/* eslint-disable */
import Preloader from "./preloader";

class PostFilter {

  constructor(options) {

    this.settings = $.extend({
      ajaxLoadedCallback: null,
      template: '',
      itemsContainer: $('#itemsContainer'),
      loadmoreWrapper: $('#loadMore'),
      loaderContainer: $('#loaderContainer'),
      container: $('div.gridFilters'),
      filtersContainer: $('#filterswrapper'),
    },options);

    this.preloader = new Preloader({container: this.settings.loaderContainer});

    if( this.settings.itemsContainer.lenght === 0 ){
      return;
    }

    this.filters = {};

    this.filtercounter = this.settings.container.find('.filters-counter');
    this.customPostType = this.settings.container.data('cpt');
    this.order = this.settings.container.data('order');
    this.orderby = this.settings.container.data('order-by');
    this.postperpage = this.settings.container.data('posts-per-page');
    this.nonce = this.settings.container.data('nonce');
    this.loadmore = this.settings.loadmoreWrapper.find('.btn');
    this.isArchive = this.settings.container.data('archive');
    this.year_archive = this.settings.container.data('year');

    // se true permette di selezionare un solo filtro per volta per ogni tassonomia
    // es. 1 categoria e un tag
    this.exclusiveFilter = this.settings.container.data('exclusive-filter') === '1' ? true : false;
    // se true permette di selezionare un solo filtro alla volta tra tutte le tassonomie
    // es. 1 categoria oppure un tag ma non entrambi
    this.filterOnce = this.settings.container.data('filter-once') === 1 ? true : false;

    // this.closeFilters = $('#closeFilter');

    // per paginazione
    this.current_page = 0;
    this.next_page = 1;
    this.total_page = 1;

    this.init();

  }

  init() {

    this.loadFilters();
    this.resetSearch();
    //this.handleInfiniteScroll();
    this.handleActions();

    // all'inizio carica i primi risultati
    this.getItems();

  }


  /**
   * Gestisce lo scroll infinito della pagina
   */
  /*handleInfiniteScroll() {

    var self = this;

    this.scene = new ScrollMagic.Scene({triggerElement: "#loaderContainer", triggerHook: "onEnter"})
      .addTo(self.scrollController)
      .on("enter", function (e) {

        if (!self.preloader.isActive && self.current_page < self.total_page) {
          self.getItems();
        }

      });
  }*/

  /*scrollTop() {
    window.scrollTo(0, 0);
  }

  disableScroll() {
    window.addEventListener('scroll', this.scrollTop);
  }

  enableScroll() {
    window.removeEventListener('scroll', this.scrollTop);
  }*/

  handleActions() {

    let self = this;

    $('.filter:not(".filter--all")').each(function () {

      $(this).on('click', function (event) {

        let $this = $(this);

        $this.toggleClass('filter--active');

        if( self.filterOnce && self.settings.filtersContainer !== null) {
          self.settings.filtersContainer.find('button').not($this).removeClass('filter--active');
        }
        if ( ! self.filterOnce && self.exclusiveFilter ) {
          $this.closest('ul').find('button').not($this).removeClass('filter--active');
        } else {
          // disattiva sempre il bottone "ALL"
          $('.filter--all').removeClass('filter--active');
        }

        self.settings.filtersContainer.find('.filters').removeClass('filters--open');

        self.loadFilters();
        self.resetSearch();
        self.getItems();

      });
    });

    $('.filter--all').on('click', function (event) {
      
      let $this = $(this);

      $this.addClass('filter--active');

      self.settings.filtersContainer.find('.filter--active').not($this).removeClass('filter--active');

      // self.settings.filtersContainer.find('.filters').removeClass('filters--open');

      self.loadFilters();
      self.resetSearch();
      self.getItems();

    });

    self.loadmore.on('click', function (event) {

      let $this = $(this);

      if ( !self.preloader.isActive && self.current_page < self.total_page ) {
        self.getItems();
      }

    });

    // X per chiudere il pannello dei filtri
    /*self.closeFilters.on('click', function (event) {
      self.settings.container.find('.filters').removeClass('filters--open');
    });*/

  }


  /**
   * Seleziona tutti i checkbox checked e prepara l'oggetto che
   * serve per filtrare i risultati
   */
  loadFilters() {

    let self = this;

    this.filtercounter.removeClass('filters-counter--active');

    // reset dei filtri precedenti
    this.filters = {};

    $('.filter--active').each(function () {
      self.addFilter($(this).data('taxonomy'), $(this).data('term_id'));
    });

  }

  /**
   * Conta il numero di filtri attivi e aggiorna il contatore nella pagina
   * se necessario
   */
  countActiveFilters() {

    // reset dei filtri precedenti
    if( Object.keys(this.filters).length === 0 ) {
      this.filtercounter.removeClass('filters-counter--active');
      return;
    }

    let counter = 0;

    Object.keys(this.filters).forEach( ( taxonomy ) => {
        counter += this.filters[ taxonomy ].length;
    });

    if( counter > 0 ) {
      this.filtercounter.html( '( ' + counter + ' )' ).addClass('filters-counter--active');
    }

  }


  /**
   * Azzera la ricerca
   */
  resetSearch() {

    this.settings.itemsContainer.hide()
      .html('')
      .removeAttr('style');

    // this.scrollTop();
    this.current_page = 0;
    this.next_page = 1;
    this.total_page = 1;

  }


  /**
   * Aggiunge un filtro all'oggetto che contiene
   * tutti i filtri attivi divisi per tassonomia
   *
   * @param taxonomy nome della tassonomia
   * @param value valore del filtro
   */
  addFilter(taxonomy, value) {

    if( taxonomy === '') {
      return;
    }

    if ( ! this.filters.hasOwnProperty(taxonomy) ) {
      this.filters[taxonomy] = [];
    }

    // se c'è allora lo rimuove perchè è un toogle
    const index = this.filters[taxonomy].indexOf(value);

    if ( index !== -1 ) {
      this.filters[taxonomy].splice(index, 1);
    }
    else {
      this.filters[taxonomy].push(value);
    }

    // aggiorna il numero di filtri attivi
    this.countActiveFilters();

  }


  getItems() {

    let self = this;

    // stop condition
    if (self.current_page >= self.total_page) {
      return;
    }

    if (self.preloader.isActive) {
      return;
    }

    self.settings.loadmoreWrapper.removeClass('loadMore--active');
    self.preloader.start();

    let data = {
      'filters': self.filters,
      'cpt': self.customPostType,
      'paged': self.next_page,
      'order': self.order,
      'orderby': self.orderby,
      'posts_per_page': self.postperpage,
      'nonce': self.nonce,
      'template': self.settings.template,
      'isarchive' : self.isArchive,
      'year' : self.year_archive,
    };

    $.post(window.ajax_url + '?action=sf_get_post_filtered', data)
      .done(function (response) {

        if (response.success) {
          self.settings.itemsContainer.append(response.data.elements);
          self.total_page = parseInt(response.data.pages);
          self.current_page = parseInt(response.data.current_page);
          self.next_page = parseInt(response.data.next_page);
        }

        self.preloader.stop();

        // call onstopCallback if exist
        if (self.settings.ajaxLoadedCallback !== null) {
          self.settings.ajaxLoadedCallback(self.settings.itemsContainer, response.data.elements);
        }

        if (self.current_page < self.total_page) {
          self.settings.loadmoreWrapper.addClass('loadMore--active');
        }

      });

  }

}

export default PostFilter;



// WEBPACK FOOTER //
// ./scripts/classes/postfilter.js